import { observer } from 'mobx-react-lite';
import { ComponentProps, ReactElement } from 'react';

export const AddIcon = observer(
  (props: ComponentProps<'svg'>): ReactElement => (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <g clipPath='url(#clip0_796_6007)'>
        <path
          d='M15.0001 10.8333H10.8334V15C10.8334 15.4583 10.4584 15.8333 10.0001 15.8333C9.54175 15.8333 9.16675 15.4583 9.16675 15V10.8333H5.00008C4.54175 10.8333 4.16675 10.4583 4.16675 9.99996C4.16675 9.54163 4.54175 9.16663 5.00008 9.16663H9.16675V4.99996C9.16675 4.54163 9.54175 4.16663 10.0001 4.16663C10.4584 4.16663 10.8334 4.54163 10.8334 4.99996V9.16663H15.0001C15.4584 9.16663 15.8334 9.54163 15.8334 9.99996C15.8334 10.4583 15.4584 10.8333 15.0001 10.8333Z'
          fill='currentColor'
        />
        <path
          d='M15.0001 10.8333H10.8334V15C10.8334 15.4583 10.4584 15.8333 10.0001 15.8333C9.54175 15.8333 9.16675 15.4583 9.16675 15V10.8333H5.00008C4.54175 10.8333 4.16675 10.4583 4.16675 9.99996C4.16675 9.54163 4.54175 9.16663 5.00008 9.16663H9.16675V4.99996C9.16675 4.54163 9.54175 4.16663 10.0001 4.16663C10.4584 4.16663 10.8334 4.54163 10.8334 4.99996V9.16663H15.0001C15.4584 9.16663 15.8334 9.54163 15.8334 9.99996C15.8334 10.4583 15.4584 10.8333 15.0001 10.8333Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_796_6007'>
          <rect
            width='20'
            height='20'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
);
